import { useSendAnswers } from 'hooks/useSendAnswers'
import { useForm } from 'react-hook-form'
import { Question } from 'types/types'
import type { FormData } from 'components/forms/DynamicForm'
import { getDefaultWorkflowValues, parseFormData } from 'types/utils'

export const useWorkflowForm = (
  questions: Question[],
  gameId: number,
  gate: string | null,
  onFormSubmit?: () => void,
) => {
  const defaultValues = getDefaultWorkflowValues(questions)

  const { handleSubmit, reset, watch, control, formState } = useForm<FormData>({
    defaultValues,
  })

  const { mutate } = useSendAnswers()
  const formData = watch()

  const onSubmit = (data: FormData) => {
    const parsedFormData = parseFormData(data, gameId, gate)
    mutate(parsedFormData, {
      onSuccess: () => {
        if (onFormSubmit) {
          onFormSubmit()
        }
      },
    })
    reset(defaultValues)
  }

  return { onSubmit, formData, defaultValues, formState, handleSubmit, control }
}
